import React, { Fragment, useEffect, useState } from 'react';
import { Breadcrumb, Row, Form, Col, Container, Alert,Card } from "@deere/ux.uxframe-react"; 
import '../../index.css'
import { useLocation, Link } from 'react-router-dom';
import {useAuthConfig} from "../../shared/utils";
import Moment from 'moment';
import { ERROR_MESSAGE } from '../../shared/Constants';
import { Loading } from '../../shared/Loading';
import {useOktaAuth} from "@okta/okta-react";
import { useUserInfo } from "../../shared/UserInfo";

export default function RequestDetails({match}) {
    const {authState} = useOktaAuth();
    const info = useUserInfo();
    const [alertVisible, setAlertVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState("");
    let authAxios = useAuthConfig();
    const [details, getDetails] = useState([]);
    //const location = useLocation();
    const URL = `/PDCReturn/requestDetails/` + match.params.material + "/" + match.params.requestorId + "/" + match.params.requestDate
    const makeMessageHidden = () => { 
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, 5000)
        return () => clearTimeout(timeout)
    }
    const hideAlert = () => {  
        setAlertVisible(false)
    }
    useEffect(() => {
        if(authState.accessToken!==null){
            getWithAxios();
        }
        
    }, [authState]);

    const getWithAxios = async () => {
        await authAxios.get(URL
        ).then(res => {
            getDetails(res.data);
            setIsLoading(false);
        }).catch(err => {              
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsLoading(false);
            makeMessageHidden()
        }
        );
    };

    return (
        <Fragment>
            <title>Display PDC Parts Request Form</title>
            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant="warning" aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}

            {isLoading ? (
                <Loading />
            ) : 
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    {match.params.flagFromPage === "requestlist" && <Breadcrumb links={[{
                                        title: "Home",
                                        href: "/"
                                    }, {
                                        title: "Request List",
                                        href: "/"
                                    }, {
                                        title: "Request Details",
                                    }]} label="breadcrumbs" />}


                                    {match.params.flagFromPage === "searchlist" && <Breadcrumb links={[{
                                        title: "Home",
                                        href: "/"
                                    }, {
                                        title: "Search List",
                                        href: "/search"
                                    }, {
                                        title: "Request Details",
                                    }]} label="breadcrumbs" />}

                                    {match.params.flagFromPage === "step2" && <Breadcrumb links={[{
                                        title: "Home",
                                        to: "/"
                                    }, {
                                        title: "Step1",
                                        to: "/step1"
                                    }, {
                                        title: "Step2",
                                        to: {
                                            pathname: "/step2", state: {
                                                plant: details.plant,
                                                material: match.params.material,
                                                quantity: match.params.quantity
                                            }
                                        }
                                    }, {
                                        title: "Request Details",
                                    }]}label="breadcrumbs"
                                    breadcrumbItemProps={{ linkAs: Link }} />}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                    <div>

                        {details.shipDate !== "" &&
                            <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                                <Card.Body>
                                    <div style={{ color: 'brown' }}>Replenishment plan may be required.  Review in CWIS and submit as necessary considering CWIS standard values and following inputs:</div>

                                    <div>
                                        <tr> <td>Typical replenishment source:</td><td id="validation">{details.typicalReplenishmentSource}</td></tr>
                                        <tr><td>Replenishment source for this order:</td><td id="validation">{details.replenishmentSourceForThisOrder}</td></tr>
                                        <tr> <td>Ship date:</td><td id="validation">{details.shipDate}</td></tr>
                                        <tr> <td>Replenishment Factory:</td><td id="validation">{details.replenishmentFactory}</td></tr>
                                    </div>

                                </Card.Body>
                            </Card>}

                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>
                                <caption>Basic Information</caption>
                                <tbody>
                                    <tr>
                                        <td>Plant:</td><td id="validation">{details.plant}</td>

                                    </tr>
                                    <tr>
                                        <td>Part:</td><td id="validation">{details.part}</td>

                                    </tr>
                                    <tr>
                                        <td>Requestor:</td><td id="validation">{details.requestorName}</td>
                                    </tr>
                                    <tr>
                                        <td>Requested On:</td><td id="validation">{Moment(details.requestDate).format('h:mm:ss A')} ON {Moment(details.requestDate).format('DD-MMM-yyyy')}</td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>{details.partID === "N" ? <td id="validation">New</td> : details.partID === "I" ? <td id="validation">In Process</td> : details.partID === "A" ? <td id="validation">Approved</td> :
                                            details.partID === "D" ? <td id="validation">Denied</td> : details.partID === "C" ? <td id="validation">Requestor Canceled</td> : <td id="validation">Unknown</td>}

                                    </tr>
                                    <tr>
                                        <td>Processed On:</td>{details.partID !== "N" && <td id="validation"> {Moment(details.processDate).format('h:mm:ss A')} ON {Moment(details.processDate).format('DD-MMM-yyyy')}</td>}
                                    </tr>
                                    <tr>
                                        <td>Processor:</td><td id="validation">{details.processorName}</td>
                                    </tr>
                                    <tr>
                                        <td>Part Description: </td><td id="validation">{details.pdcPartDesc}</td>

                                    </tr>
                                    <tr>
                                        <td>Reason:</td><td id="validation">{details.reason}</td>
                                    </tr>

                                    <tr>
                                        <td>Quantity:</td><td id="validation">{details.quantity}</td>
                                    </tr>

                                    <tr>
                                        <td>Urgency:</td><td id="validation">{details.urgency}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
                        </Card>

                        {details.destination !== "other" ? <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <h6 style={{ fontWeight: "bold" }}>Delivery Information</h6>


                                <tbody>
                                    <tr>
                                        <td>Company Name:</td><td id="validation">{details.companyName}</td>
                                    </tr>
                                    <tr>
                                        <td>Attention:</td><td id="validation">{details.attention}</td>
                                    </tr>
                                    <tr>
                                        <td>Address:</td><td id="validation">{details.address} </td>{details.dept !== "" && <td style={{ paddingLeft: "10px" }}> Dept: {details.dept}</td>}{details.dock !== "" && <td style={{ paddingLeft: "10px" }}>Dock: {details.dock}</td>}

                                    </tr>
                                    <tr>
                                        <td>City:</td><td id="validation">{details.city}</td>
                                    </tr>
                                    <tr>
                                        <td>State:</td><td id="validation">{details.state}</td>
                                    </tr>
                                    <tr>
                                        <td>Country:</td><td id="validation">{details.country}</td>
                                    </tr>
                                    <tr>
                                        <td>Zip:</td><td id="validation">{details.zip}</td>
                                    </tr>
                                    {details.destination === "Ryder" &&
                                        <tr><td>DY Account Number:</td><td id="validation">DYRW01</td></tr> //hardcoded value not coming from backend
                                    }
                                </tbody>

                            </Card.Body>
                        </Card> : <><Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <caption>Delivery Information</caption>


                                <tbody>
                                    <tr>
                                        <td>Company Name:</td>
                                        <td id="validation">{details.companyName}</td>
                                    </tr>
                                    <tr>
                                        <td>Attention:</td>
                                        <td id="validation">{details.attention}</td>
                                    </tr>
                                    <tr>
                                        <td>Address:</td>
                                        <td id="validation">{details.address}</td>{ }
                                    </tr>
                                    <tr>
                                        <td>City:</td>
                                        <td id="validation">{details.city}</td>
                                    </tr>
                                    <tr>
                                        <td>State:</td>
                                        <td id="validation">{details.state}</td>
                                    </tr>
                                    <tr>
                                        <td>Country:</td>
                                        <td id="validation">{details.country}</td>
                                    </tr>
                                    <tr>
                                        <td>Zip:</td>
                                        <td id="validation">{details.zip}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone:</td>
                                        <td id="validation">{details.contact}</td>
                                    </tr>


                                </tbody>

                            </Card.Body>
                        </Card><Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                                <Card.Body>

                                    <caption>Charge Information</caption>


                                    <tbody>
                                        <tr>
                                            <td>Company Name:</td><td id="validation">{details.companyName}</td>
                                        </tr>

                                        {details.production === "no" &&
                                            <>
                                                {details.charge === "D" &&
                                                    <tr>
                                                        <td>Charge Account:</td><td id="validation">{details.chargeAccount} and Department: {details.department}</td>
                                                    </tr>}
                                                {details.charge === "S" &&
                                                    <>
                                                        <tr>
                                                            <td>Charge Supplier:</td><td id="validation">{details.chargeAccount}</td>
                                                        </tr><tr>
                                                            <td>Supplier PO:</td><td id="validation">{details.department}</td>
                                                        </tr></>}</>}
                                        <tr>
                                            <td>Charge Reason:</td><td id="validation">{details.chargeReason}</td>
                                        </tr>


                                    </tbody>

                                </Card.Body>
                            </Card></>
                        }

                        {details.processorNote !== "" &&
                            <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                                <Card.Body>
                                    <caption>Optional Information</caption>
                                    <tbody>
                                    <tr>
                                            <td>Final Comments from requestor:</td><td id="validation">{details.processorNote}</td>
                                        </tr>
                                        <tr>
                                            <td>Additional people to Notify:</td><td id="validation">{details.additionalCCEmails}</td>
                                        </tr>

                                    </tbody>

                                </Card.Body>
                            </Card>} 
							
							<Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
							<Card.Body>

                                <h6 style={{ fontWeight: "bold" }}>Factory Inventory Scenario</h6>


                                <tbody>
                                    <tr>
                                        <td>Pcs of Inventory at my factory:</td><td id="validation">{details.pcsOfInventory}</td>
                                    </tr>
                                    <tr>
                                        <td>Factory daily usage:</td><td id="validation">{details.factoryDailyUsage}</td>
                                    </tr>
                                    <tr>
                                        <td>Suppliers next shipment to factory will arrive (xx/mm/yyyy):</td><td id="validation">{details.nextShipmentDate}</td>
                                    </tr>
                                    <tr>
                                        <td>Requestor comments on factory inventory situation – why is this order needed from PDC?:</td><td id="validation">{details.whyNeededFrmPDC}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
							</Card>
                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <caption>Additional Information</caption>


                                <tbody>
                                    <tr>
                                        <td>Part location:</td>{details.location === "ADC" ? <td id="validation">Davenport, Iowa</td> : details.location === "PDC" ? <td id="validation">Milan, Illinois</td> : <td id="validation">Unknown</td>}
                                    </tr>
                                    <tr>
                                        <td>Earliest ETA:</td>{details.urgency === "2 Weeks" ? <td id="validation">{details.userETA.substring(0, 10)}</td> : <td id="validation">{details.userETA}</td>}
                                    </tr>
                                    <tr>
                                        <td>Ship Method:</td><td id="validation">{details.shipMethIMS} : {details.shipMethUser}</td>
                                    </tr>
                                    <tr>
                                        <td>Estimated to Deliver By:</td><td id="validation">{details.deliverBy}</td>
                                    </tr>


                                </tbody>

                            </Card.Body>
                        </Card>
                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <caption>JDPoint Information</caption>


                                <tbody>
                                    <tr>
                                        <td>Dimensions:</td><td id="validation">Cube: {details.dimensionCube} Largest: {details.dimensionL} Middle: {details.dimensionM} Smallest: {details.dimensionS}</td>
                                    </tr>
                                    <tr>
                                        <td>Actual Quantity:</td><td id="validation">{details.actualQuantity}</td>
                                    </tr>
                                    <tr>
                                        <td>DY Order Number:</td><td id="validation">{details.dyOrder}</td>
                                    </tr>
                                    <tr>
                                        <td>Final ETA:</td>{details.partID === "A" && <td id="validation">{details.finalETA}</td>}
                                    </tr>
                                    <tr>
                                        <td>Note From Processor:</td><td id="validation">{details.finalCommentsFromRequestor}</td>
                                    </tr>
                                    <tr>
                                        <td>PDC Returns:</td><td id="validation">{details.pdcReturn}</td>
                                    </tr>
                                    <tr>
                                        <td>Delivery:</td><td id="validation">{details.delivery}</td>
                                    </tr>

                                </tbody>

                            </Card.Body>
                        </Card>

                    </div>
                </Card.Body></Card>}
        </Fragment>
    );

}


